const DEBOUNCE_MILLISECONDS = 100;
const TOP_THRESHOLD = 94;

export const handleExitIntent = (onExitIntent: () => void) => {
  let hasTriggeredExitIntent = false;
  let lastMoveTime = 0;

  // Desktop exit intent detection
  const handleDesktopExit = (event: MouseEvent) => {
    const now = Date.now();

    if (now - lastMoveTime < DEBOUNCE_MILLISECONDS) {
      return;
    }

    lastMoveTime = now;

    // Check if mouse is near the top of the viewport
    if (event.clientY <= TOP_THRESHOLD && !hasTriggeredExitIntent) {
      hasTriggeredExitIntent = true;
      document.removeEventListener('mousemove', handleDesktopExit);
      onExitIntent();
    }
  };

  // Mobile exit intent detection
  let touchStartY = 0;
  let touchStartTime = 0;
  let touchStartX = 0;

  const handleTouchStart = (event: TouchEvent) => {
    touchStartY = event.touches[0].clientY;
    touchStartX = event.touches[0].clientX;
    touchStartTime = Date.now();
  };

  const handleTouchEnd = (event: TouchEvent) => {
    if (hasTriggeredExitIntent) {
      return;
    }

    const touchEndY = event.changedTouches[0].clientY;
    const touchEndX = event.changedTouches[0].clientX;
    const touchEndTime = Date.now();
    const touchDuration = touchEndTime - touchStartTime;
    const touchDistanceY = touchEndY - touchStartY;
    const touchDistanceX = Math.abs(touchEndX - touchStartX);

    // Only trigger if the swipe is mostly vertical (less than 45 degrees)
    const isMostlyVertical = touchDistanceX < Math.abs(touchDistanceY);

    // Detect if user is trying to close the app or switch tabs
    // This happens when they swipe down quickly from the top of the screen
    if (touchDuration < 300 && touchDistanceY > 100 && isMostlyVertical) {
      hasTriggeredExitIntent = true;
      onExitIntent();
    }
  };

  window.addEventListener('mousemove', handleDesktopExit);
  window.addEventListener('touchstart', handleTouchStart);
  window.addEventListener('touchend', handleTouchEnd);

  return () => {
    window.removeEventListener('mousemove', handleDesktopExit);
    window.removeEventListener('touchstart', handleTouchStart);
    window.removeEventListener('touchend', handleTouchEnd);
  };
};
